/* unplugin-vue-components disabled */import { render } from "./source-item.vue?vue&type=template&id=af3c9092&scoped=true"
import script from "./source-item.vue?vue&type=script&lang=js"
export * from "./source-item.vue?vue&type=script&lang=js"

import "./source-item.vue?vue&type=style&index=0&id=af3c9092&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3c9092"],['__file',"src/components/sources-v2/source-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af3c9092"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af3c9092', __exports__)) {
    api.reload('af3c9092', __exports__)
  }
  
  module.hot.accept("./source-item.vue?vue&type=template&id=af3c9092&scoped=true", () => {
    api.rerender('af3c9092', render)
  })

}


export default __exports__